import { render, staticRenderFns } from "./VehDetReq.vue?vue&type=template&id=6ea429e0&"
import script from "./VehDetReq.vue?vue&type=script&lang=js&"
export * from "./VehDetReq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports